export default "__VITE_ASSET__sFhCkoeo__"